import Vue from 'vue/dist/vue.esm.js';
import TurbolinksAdapter from 'vue-turbolinks'
import { globalMixin } from '../mixins/global'
import Slick from "vue-slick";
import '../../../node_modules/slick-carousel/slick/slick.css'
import '../../../node_modules/slick-carousel/slick/slick-theme.css'
import '../../../node_modules/slick-carousel/slick/ajax-loader.gif'
import {estatePropertyMixin} from "../mixins/estate_properties";

Vue.use(TurbolinksAdapter)

document.addEventListener('turbolinks:load', () => {
  const element = document.getElementById("vue-estate_properties-show")
  if (element) {
    window.vueLoaded = true

    const app = new Vue({
      el: element,
      mixins: [
        globalMixin,
        estatePropertyMixin,
      ],
      components: { Slick },
      data: () => {
        return {
        }
      },
      methods: {
      }
    })
  }
})
